import React from "react";

import { CircularProgress } from "@mui/material";
import { Constants as GridConstants } from "Components/AppGrid/shipeezi-new-grid";
import { useTranslation } from "react-i18next";
import { FiPrinter } from "react-icons/fi";

import { DefaultTooltip } from "../../../../../../components/Generic/Tooltip";
import useStyles from "../../styles";

interface Props {
  id: number;
  loading: boolean;
  handleOnClick: (id: number) => void;
}

const PrintDeliveryDocketButton = (props: Props) => {
  const { id, handleOnClick, loading } = props;

  const { t: translate } = useTranslation();
  const classes = useStyles();

  if (loading) return <CircularProgress size={20} />;

  return (
    <DefaultTooltip title={translate("print")} placement="top">
      <div>
        <FiPrinter
          size={GridConstants.defaultRowActionSize}
          color={GridConstants.defaultColorIcon}
          className={classes.button}
          data-cy="printButton"
          onClick={() => {
            handleOnClick(id);
          }}
        />
      </div>
    </DefaultTooltip>
  );
};

export default PrintDeliveryDocketButton;
